<template>
  <section id="notifications">
    <div class="demo">
      <div class="alert notification-info alert-dismissible fade show" role="alert">
          <i class="gel-icon-info gel-icon-lg" aria-hidden="true"></i>
          This is a info notification
          <a class="notification-link" href="#">check it out!</a>
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <i class="gel-icon-close gel-icon-lg" aria-hidden="true"></i>
          </button>
      </div>
      <div class="alert notification-success alert-dismissible fade show" role="alert">
          <i class="gel-icon-tick-circle gel-icon-lg" aria-hidden="true"></i>
          This is a success notification!
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <i class="gel-icon-close gel-icon-lg" aria-hidden="true"></i>
          </button>
      </div>
      <div class="alert notification-danger" role="alert">
          <i class="gel-icon-error gel-icon-lg" aria-hidden="true"></i>
          This is a danger, please
          <a class="notification-link" href="#">take an action now</a>
      </div>
      <div class="alert notification-warning" role="alert">
          <i class="gel-icon-warning gel-icon-lg" aria-hidden="true"></i>
          You are currently controlling John Smith's account,
          <a href="#" class="notification-link">Go back to your account</a>
      </div>
    </div>  
    <section class="md" v-html="notMd"></section>
  </section>
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
import notMd from "@/docs/components/notification.md";
export default {
  name: "notifications",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.notifications.name);
    this.$emit("update-tagline", this.$root.yamlData.components.notifications.description);
  },
  mounted: function () {
    const closeAlerts = document.querySelectorAll('[data-dismiss="alert"]')
    closeAlerts.forEach(alert => {
      new BSN.Alert(alert)
    })
  },
  data() {
    return {
      notMd
    };
  }
};
</script>
